export default __webpack_public_path__ + "static/media/event_page_bg1.18209e66.png";